var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Step as MuiStep, StepIcon, stepLabelClasses } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledStepConnector, StyledStepLabel, StyledStepper } from '../common/stepperStyles';
import { ORG_CONFIG_STEPS, OrgConfigStep, STEP_NAME } from './constants';
import { OrgConfigWizardContext } from './context';
import { useLocationsAPI } from './selectors';
var CircleStep = function (props) {
  return _jsx(StepIcon, __assign({}, props, {
    completed: false
  }));
};
var Step = function (_a) {
  var _b, _c;
  var value = _a.value,
    props = __rest(_a, ["value"]);
  var stepName = STEP_NAME[value];
  var t = useTranslation('orgConfig').t;
  var _d = useContext(OrgConfigWizardContext),
    stepIndex = _d.stepIndex,
    goToStep = _d.goToStep,
    isSaving = _d.isSaving,
    setIsSaving = _d.setIsSaving,
    beforeNext = _d.beforeNext,
    configVersionId = _d.configVersionId,
    isViewOnly = _d.isViewOnly;
  var locationsData = useLocationsAPI(configVersionId)[0];
  var hasAtLeastOneLocation = STEP_NAME[stepIndex] === 'clientsLobs' || ((_c = (_b = locationsData.data) === null || _b === void 0 ? void 0 : _b.locations) !== null && _c !== void 0 ? _c : []).length >= 1;
  var valueStepIndex = ORG_CONFIG_STEPS.indexOf(value);
  var isPastStep = valueStepIndex < stepIndex;
  var isFutureStep = valueStepIndex > stepIndex;
  var isCompleted = stepIndex > valueStepIndex && !isViewOnly;
  var isClickable = !isViewOnly && !isSaving && (isPastStep || isFutureStep && hasAtLeastOneLocation);
  var handleClick = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var canNavigate;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!isClickable) return [2 /*return*/];
            if (!beforeNext) return [3 /*break*/, 4];
            setIsSaving(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1,, 3, 4]);
            return [4 /*yield*/, beforeNext()];
          case 2:
            canNavigate = _a.sent();
            if (!canNavigate) return [2 /*return*/];
            return [3 /*break*/, 4];
          case 3:
            setIsSaving(false);
            return [7 /*endfinally*/];
          case 4:
            goToStep(valueStepIndex);
            return [2 /*return*/];
        }
      });
    });
  };
  return _jsx(MuiStep, __assign({}, props, {
    completed: isCompleted
  }, {
    children: _jsx(StyledStepLabel, __assign({
      StepIconComponent: CircleStep,
      sx: function (theme) {
        var _a;
        return __assign({
          fontSize: 20
        }, isClickable && (_a = {}, _a["& .".concat(stepLabelClasses.label)] = {
          color: theme.palette.primary.main,
          textDecoration: 'underline',
          textUnderlineOffset: theme.typography.pxToRem(2),
          cursor: 'pointer'
        }, _a));
      },
      color: "inherit",
      onClick: isClickable ? function () {
        void handleClick();
      } : undefined
    }, {
      children: t("orgConfigWizard.".concat(stepName), {
        defaultValue: value === OrgConfigStep.Financials ? 'Add financials' : stepName
      })
    }))
  }));
};
export var OrgConfigSteps = function () {
  var stepIndex = useContext(OrgConfigWizardContext).stepIndex;
  return _jsx(StyledStepper, __assign({
    nonLinear: true,
    alternativeLabel: true,
    activeStep: stepIndex,
    connector: _jsx(StyledStepConnector, {})
  }, {
    children: ORG_CONFIG_STEPS.map(function (stepValue) {
      return _jsx(Step, {
        value: stepValue
      }, stepValue);
    })
  }));
};